import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const RoofingPackages = () => {
  useEffect(() => {
    analytics.track('Template Page View', { template: 'Roofing Quote Template' });
  }, []);

  return (
    <SEOPageLayout
      title="Free Roofing Quote Template - Tiered Options (Good/Better/Best) | QuoteTier"
      description="Free roofing contractor quote template with Good/Better/Best tiers. From leak repair to full designer-shingle replacement, priced side-by-side."
      canonical="/templates/roofing-packages-template"
      ogTitle="Free Roofing Quote Template"
      ogDescription="Roofers who only quote the repair lose the 'while the crew is here' full-replace conversation. Three tiers on one quote fix that."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              Free <span className="text-primary font-bold">Roofing Quote Template</span>
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              From a leak patch to a full architectural shingle tear-off — let homeowners weigh repair vs replace on the same quote.
            </p>
            <div className="max-w-2xl mx-auto mb-10 p-5 border border-gray-200 rounded-lg bg-gray-50 text-left">
              <p className="font-jetbrains text-sm md:text-base text-gray-700 leading-relaxed">
                Roof repair customers are often one storm away from needing a full replacement anyway. Repair, partial replace, and full tear-off as three tiers means the "should we just replace it all?" conversation happens during the quote — not after the next ceiling stain.
              </p>
            </div>
            <div className="font-instrument mt-8 flex flex-col sm:flex-row gap-6 justify-center items-center mb-3">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Use This Template Free
                </Button>
              </Link>
            </div>
            <p className="font-jetbrains text-sm text-gray-500 mb-6">Free account — no credit card required.</p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">Sample Tiers</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Repair</CardTitle><CardDescription>The Budget Option</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Leak patch & shingle replace</li>
                      <li>Flashing repair</li>
                      <li>2-year workmanship warranty</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black bg-black text-white">
              <CardHeader><CardTitle className="font-instrument text-xl text-white">Partial Replace</CardTitle><CardDescription className="text-gray-300">Best Seller</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-300 list-disc list-inside">
                      <li>Up to 50% roof replacement</li>
                      <li>Architectural shingles</li>
                      <li>Underlayment upgrade</li>
                      <li>5-year workmanship warranty</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Full Replace</CardTitle><CardDescription>Complete Solution</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Full tear-off & replace</li>
                      <li>Top-tier designer shingles</li>
                      <li>Ridge vent & ice shield</li>
                      <li>10-year workmanship warranty</li>
                  </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Start Using This Template Now</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Get Free Access
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default RoofingPackages;
